import { FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import ResponsiveSheet from "@Components/ResponsiveSheet/ResponsiveSheet";
import { BagIcon } from "src/assets/Icons";
import { type MiniRule } from "src/Modules/Flights/constants/JourneyListing";
import MiniFareRulesContent from "./components/MiniFareRulesContent";

const MiniFareRules: FC<{ miniRules: MiniRule[][] }> = ({ miniRules }) => {
  const { t } = useTranslation();

  if (miniRules.length === 0) return null;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <ResponsiveSheet
        label={<div className="font-inter text-sm font-bold md:text-xl">{t("Flights.listing.fareRules")}</div>}
        modalProps={{ zIndex: 50, mask: { closable: true, blur: true, enabled: true } }}
        renderTrigger={({ open }) => (
          <Button
            className="hover:bg-transparent! text-primary-60! hover:text-primary-60! duration-300! md:border-dashed! border-none! shadow-none! md:px-5! md:py-1! p-0! m-0!"
            onClick={open}
            icon={<BagIcon />}
            iconPlacement="end"
          >
            {t("Flights.listing.fareRules")}
          </Button>
        )}
        renderSheet={({ close }) => (
          <div className="p-4">
            <MiniFareRulesContent miniRules={miniRules} onClose={close} />
          </div>
        )}
      />
    </div>
  );
};

export default MiniFareRules;
